(() => {
  const SEARCH_PATH = '/search';
  const GENERATED_FILTER = 'data-jb-precise-search-filter';

  const stripQuotes = (value) => {
    const trimmed = value.trim();
    if (trimmed.length >= 2 && trimmed.startsWith('"') && trimmed.endsWith('"')) {
      return trimmed.slice(1, -1).trim();
    }
    return trimmed;
  };

  const normalizedNumber = (value) => {
    const number = Number.parseFloat(String(value).replace(',', '.'));
    if (!Number.isFinite(number)) return String(value);
    return Number.isInteger(number) ? String(number) : String(number).replace(/0+$/, '').replace(/\.$/, '');
  };

  const buildPreciseSearch = (value) => {
    const raw = stripQuotes(value);
    const compact = raw.replace(/\s+/g, '');
    let match;

    match = compact.match(/^(\d{2})[xX×](\d{1,2}(?:[.,]\d+)?)$/);
    if (match) {
      const diameter = Number.parseInt(match[1], 10);
      const width = Number.parseFloat(match[2].replace(',', '.'));
      if (diameter >= 12 && diameter <= 30 && width >= 4 && width <= 20) {
        const canonical = `${diameter}x${normalizedNumber(match[2])}`;
        return {
          query: canonical,
          filters: {
            'filter.p.m.custom.diametre_roue': String(diameter),
            'filter.p.m.custom.largeur_roue': normalizedNumber(match[2]),
          },
        };
      }
    }

    match = compact.match(/^(\d{1,2})[xX×](\d{2,3}(?:[.,]\d+)?)$/);
    if (match) {
      const lugs = Number.parseInt(match[1], 10);
      const pcd = Number.parseFloat(match[2].replace(',', '.'));
      if (lugs >= 3 && lugs <= 10 && pcd >= 70 && pcd <= 300) {
        const commonShorthand = {
          '5x114': '5x114.3',
          '5x139': '5x139.7',
          '6x139': '6x139.7',
          '8x165': '8x165.1',
        };
        const entered = `${lugs}x${normalizedNumber(match[2])}`;
        const canonical = commonShorthand[entered] || entered;
        return {
          query: canonical,
          filters: { 'filter.p.m.custom.entraxe_roue': canonical },
        };
      }
    }

    match = compact.match(/^(?:(LT|P))?(\d{3})\/(\d{2,3})[Rr](\d{2})$/i);
    if (match) {
      const prefix = (match[1] || '').toUpperCase();
      const width = match[2];
      const profile = match[3];
      const rim = match[4];
      const canonical = `${prefix}${width}/${profile}R${rim}`;
      return {
        query: canonical,
        filters: {
          'filter.p.m.custom.largeur_pneu': width,
          'filter.p.m.custom.profil_pneu': profile,
          'filter.p.m.custom.diametre_pneu': rim,
        },
      };
    }

    match = compact.match(/^(\d{2,3}(?:[.,]\d+)?)[xX×](\d{1,2}(?:[.,]\d+)?)[Rr-]?(\d{2})$/i);
    if (match) {
      const overall = Number.parseFloat(match[1].replace(',', '.'));
      const width = Number.parseFloat(match[2].replace(',', '.'));
      const rim = Number.parseInt(match[3], 10);
      if (overall >= 25 && overall <= 60 && width >= 7 && width <= 20 && rim >= 10 && rim <= 30) {
        const queryOverall = match[1].replace(',', '.');
        const queryWidth = match[2].replace(',', '.');
        const canonicalOverall = normalizedNumber(match[1]);
        const canonicalWidth = normalizedNumber(match[2]);
        const canonical = `${queryOverall}x${queryWidth}R${rim}`;
        return {
          query: canonical,
          filters: {
            'filter.p.m.custom.diametre_exterieur_pneu': canonicalOverall,
            'filter.p.m.custom.largeur_pneu': canonicalWidth,
            'filter.p.m.custom.diametre_pneu': String(rim),
          },
        };
      }
    }

    return null;
  };

  const appendHiddenInput = (form, name, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute(GENERATED_FILTER, '');
    form.appendChild(input);
  };

  const prepareForm = (form) => {
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    const precise = buildPreciseSearch(input.value);
    if (!precise) return;

    form.querySelectorAll(`[${GENERATED_FILTER}]`).forEach((element) => element.remove());
    input.value = `"${precise.query}"`;
    if (!form.querySelector('input[name="type"]')) appendHiddenInput(form, 'type', 'product');
    Object.entries(precise.filters).forEach(([name, value]) => appendHiddenInput(form, name, value));
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = new URL(form.action || window.location.href, window.location.origin);
      if (action.pathname === SEARCH_PATH) prepareForm(form);
    },
    true,
  );

  if (window.location.pathname === SEARCH_PATH) {
    const url = new URL(window.location.href);
    const currentQuery = url.searchParams.get('q') || '';
    const precise = buildPreciseSearch(currentQuery);
    if (precise) {
      const quotedQuery = `"${precise.query}"`;
      let needsRedirect = currentQuery !== quotedQuery || url.searchParams.get('type') !== 'product';
      url.searchParams.set('q', quotedQuery);
      url.searchParams.set('type', 'product');
      url.searchParams.delete('page');

      Object.entries(precise.filters).forEach(([name, value]) => {
        if (url.searchParams.get(name) !== value) needsRedirect = true;
        url.searchParams.set(name, value);
      });

      if (needsRedirect) {
        window.location.replace(url.toString());
        return;
      }

      document.querySelectorAll('input[name="q"]').forEach((input) => {
        if (input instanceof HTMLInputElement) input.value = precise.query;
      });
    }
  }
})();

